<template>
  <div style="margin:  0 auto; width: 80%">
    <el-row style="height: 40px">
    <el-col >
      用户名：<el-input v-model="nick" size="small" type="text"  style="width:200px"></el-input>
      手机号：<el-input v-model="mobile" size="small" type="text"  style="width:200px"></el-input>
      <el-button type="primary" size="mini" @click="getSmsData">搜索</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table border :data="smsData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  prop="nick" label="用户名" width="160px"></el-table-column>
          <el-table-column  prop="mobile" label="手机号" width="160px"></el-table-column>
          <el-table-column  prop="content" label="内容" ></el-table-column>

          <el-table-column  prop="sendTime" label="发送时间" width="160px"></el-table-column>
          <el-table-column  prop="flag" label="验证标记" width="80px"></el-table-column>
          <el-table-column  prop="modify" label="验证时间" width="160px"></el-table-column>



        </el-table>
      </el-col>
    </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
    export default {
        name: "AdmSmsLog",
      data(){
          return{
            nick:'',
            mobile:'',
            pageObject: {
              pageCurrent: 1,
              rowCount: 9,
              pageSize: 20,
            },
            smsData:[]
          }
      },methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getSmsData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getSmsData();
        },
        getSmsData:function () {
          let param ={
            nick:this.nick,
            mobile: this.mobile,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          };
          console.log("admin");
          $api.post("/sms/get", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              let smsData = dataResult.data.sms;
              let pageObject = dataResult.data.pageObject;
              this.smsData = smsData;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else{
              this.$message.error(dataResult.message);
            }
          })
        },
      },
      mounted(){
        this.getSmsData();
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/admin/AdmSmsLog.vue